@if (breadcrumbs()) {
  <procure-breadcrumbs
    [breadcrumbs]="breadcrumbs()"
    [externalLink]="url()"
    [sapAribaLink]="sapAribaLink()"
    [orbisLink]="orbisLink()"
    [sncrpLink]="sncrpLink()"
    [gravityLink]="gravityLink()"
    [xapienLink]="xapienLink()"
    [ecoVadisLink]="ecoVadisLink()"
    [entityClickable]="entityClickable()"
  />
}
